import './AuroraBackground.css';

/** Formes dégradées floues qui dérivent lentement en arrière-plan d'un hero. Purement décoratif. */
export function AuroraBackground({ tone = 'light' }) {
  return (
    <div className={`aurora aurora--${tone}`} aria-hidden="true">
      <span className="aurora__blob aurora__blob--1" />
      <span className="aurora__blob aurora__blob--2" />
      <span className="aurora__blob aurora__blob--3" />
    </div>
  );
}
